import { render, staticRenderFns } from "./AgregarUsuario.vue?vue&type=template&id=2296bb9c&scoped=true"
import script from "./AgregarUsuario.vue?vue&type=script&lang=js"
export * from "./AgregarUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2296bb9c",
  null
  
)

export default component.exports